import { useNotificationsStore } from '~~/stores/notificationsStore'

export function useNotifications() {
  const store = useNotificationsStore()

  function success(message: string) {
    store.add({ message, type: 'success' })
  }

  function error(message: string) {
    store.add({ message, type: 'error' })
  }

  function info(message: string) {
    store.add({ message, type: 'info' })
  }

  return { success, error, info }
}
